import { useMutation, useQueryClient } from "@tanstack/react-query";
import { addQuestion } from "../../../api/reportsApi";
import { lockToast } from "../../../helpers/successToast";
import {
  EditableReportQuestion,
  QuestionDescriptionDTO,
  TemplateEditableSection,
} from "../../../types/Rows";
import { SectionEdit } from "./SectionEdit";
import { byWeight, useTemplateContext } from "../templateContext";

export const EditableSectionsList = ({
  templateId,
  sections,
  existingItems,
  saveExisting,
  isLocked,
}: {
  templateId: string;
  sections: TemplateEditableSection[];
  existingItems: QuestionDescriptionDTO[];
  saveExisting: (id: string, questionId: string) => void;
  isLocked: boolean;
}) => {
  const queryClient = useQueryClient();
  const { sectionWeights, setSectionOrder } = useTemplateContext();
  // Kolejność: niezapisana (strzałki), inaczej z serwera
  const ordered = [...sections].sort(byWeight(sectionWeights));
  const move = (index: number, direction: -1 | 1) => {
    const target = index + direction;
    if (target < 0 || target >= ordered.length) return;
    const next = [...ordered];
    [next[index], next[target]] = [next[target], next[index]];
    setSectionOrder(next);
  };

  const addItem = useMutation(
    ({
      sectionId,
      question,
    }: {
      sectionId: string;
      question: { weight: number; descriptionId: string };
    }) => addQuestion(templateId, sectionId, question),
    {
      onSuccess: () => {},
    }
  );
  
  return (
    <div className="flex flex-col gap-2">
      {ordered.map((section, i) => (
          <SectionEdit
            key={section.id}
            section={section}
            items={section.questions}
            templateId={templateId}
            index={i}
            isFirst={i === 0}
            isLast={i === ordered.length - 1}
            onMove={(direction) => move(i, direction)}
            isLocked={isLocked}
            existingItems={existingItems}
            saveNew={(sectionId, descriptionId) => {
              if (isLocked) { lockToast(); return; }
              addItem.mutate(
                {
                  sectionId,
                  question: {
                    weight: section.questions.length + 1,
                    descriptionId,
                  },
                },
                {
                  onSuccess: () => {
                    queryClient.invalidateQueries(["Templates", templateId, "Questions"]);
                  },
                }
              );
            }}
            saveExisting={(sectionId, questionId) => {
              if (isLocked) { lockToast(); return; }
              return saveExisting(sectionId, questionId);
            }}
          />
        ))}
    </div>
  );
};
